module.exports = __webpack_public_path__ + "dash_20_app_assets/img/email.0e980bb4.png";